/* eslint-disable @angular-eslint/component-selector */

import {
  ChangeDetectionStrategy,
  Component,
  Directive,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Output
} from '@angular/core';

@Directive({
  selector: '[elmButtonConfirmDefault]'
})
export class ButtonConfirmDefaultDirective {}

@Directive({
  selector: '[elmButtonConfirmActive]'
})
export class ButtonConfirmActiveDirective {}

@Component({
  selector: '[elmButtonConfirm]',
  templateUrl: 'button-confirm.component.html',
  styleUrls: ['button-confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonConfirmComponent {
  active = false;

  @Output() confirm = new EventEmitter();

  @HostBinding('class.elm-button-confirm-active') get isActive() {
    return this.active;
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    const clicked =
      this.elRef.nativeElement === event.target ||
      this.elRef.nativeElement.contains(event.target);

    if (clicked) {
      if (this.active) this.confirm.emit();

      this.active = !this.active;
    } else {
      this.active = false;
    }
  }

  constructor(private elRef: ElementRef) {}
}
